import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const RouteTitleUpdater = () => {
  const location = useLocation();

  const user = useSelector(state => state.root.user);

  useEffect(() => {
    // Update the document title based on the current route
    switch (location.pathname) {
      case "/login":
        document.title = "Login - Fr8Auctions";
        break;
      case "/user-management/staff":
        document.title = "Staff - Fr8Auctions";
        break;
      case "/user-management/buyers":
        document.title = "Buyers - Fr8Auctions";
        break;
      case "/change-password":
        document.title = "Change Password - Fr8Auctions";
        break;
      case "/auction-management":
        document.title = "Auction Management - Fr8Auctions";
        break;
      case "/user-management/staff/create-staff":
        document.title = "Create a Staff - Fr8Auctions";
        break;
      case "/user-management/staff/edit-staff":
        document.title = "Edit a Staff - Fr8Auctions";
        break;
      case "/user-management/buyers/edit-buyer":
        document.title = "Edit a Buyer - Fr8Auctions";
        break;
      case "/product-category":
        document.title = "Product Category - Fr8Auctions";
        break;
      case "/product-subcategory":
        document.title = "Product Subcategory - Fr8Auctions";
        break;
      case "/product-category/createproduct":
        document.title = "Create Product Category - Fr8Auctions";
        break;
      case "/product-category/editproduct":
        document.title = "Edit Product Category - Fr8Auctions";
        break;
      case "/product-subcategory/createsubcategory":
        document.title = "Create Subcategory - Fr8Auctions";
        break;
      case "/product-subcategory/editsubcategory":
        document.title = "Edit Subcategory - Fr8Auctions";
        break;
      case "/pallet-management":
        document.title = "Pallet Management - Fr8Auctions";
        break;
      case "/pallet-management/createPallet":
        document.title = "Create a Pallet - Fr8Auctions";
        break;
      case "/pallet-management/edit-pallet":
        document.title = "Edit a Pallet - Fr8Auctions";
        break;
      case "/notifications":
        document.title = "Notifications - Fr8Auctions";
        break;
      case "/loading-management":
        document.title = "Loading Management - Fr8Auctions";
        break;
      case "/loading-management/assign-loader":
        document.title = "Assign Loader - Fr8Auctions";
        break;
      case "/loading-details":
        document.title = "Loading Details - Fr8Auctions";
        break;
      case "/loading-details/add-loading-details":
        document.title = "Loading Details - Fr8Auctions";
        break;
      case "/loading":
        document.title = "Loading - Fr8Auctions";
        break;
      case "/loader":
        document.title = "Loader - Fr8Auctions";
        break;
      case "/loader/loader-details":
        document.title = "Loader Details - Fr8Auctions";
        break;
      case "/invoice-management":
        document.title = "Invoice Management - Fr8Auctions";
        break;
      case "/consignor-management":
        document.title = "Consignor Management - Fr8Auctions";
        break;
      case "/consignor-management/createConsignor":
        document.title = "Create a Consignor - Fr8Auctions";
        break;
      case "/consignor-management/edit-consignor":
        document.title = "Edit a Consignor - Fr8Auctions";
        break;
      case "/company-management":
        if (user?.user_role?.name.toLowerCase() === "owner") {
          document.title = "Company Profile - Fr8Auctions";
        } else {
          document.title = "Company Management - Fr8Auctions";
        }
        break;
      case "/company-management/addNewCompany":
        document.title = "Add New Company - Fr8Auctions";
        break;
      case "/company-management/editCompany":
        document.title = "Edit Company - Fr8Auctions";
        break;
      case "/company-management/company-members":
        document.title = "Company Members - Fr8Auctions";
        break;
      case "/company-management/company-members/addNewMember":
        document.title = "Add Member - Fr8Auctions";
        break;
      case "/company-management/company-members/editMember":
        document.title = "Edit Member - Fr8Auctions";
        break;
      case "/company-members":
        document.title = "Member List - Fr8Auctions";
        break;
      case "/company-members/editMember":
        document.title = "Edit Member - Fr8Auctions";
        break;
      case "/company-document":
        document.title = "Document Management - Fr8Auctions";
        break;
      case "/company-document/createdocument":
        document.title = "Document Type List - Fr8Auctions";
        break;
      case "/company-document/editdocument":
        document.title = "Edit Document - Fr8Auctions";
        break;
      case "/view-all-documents":
        document.title = "All Documents - Fr8Auctions";
        break;
      case "/view-all-documents/edituserdocument":
        document.title = "All Documents - Fr8Auctions";
        break;
      case "/auction-management/createauction":
        document.title = "Create an Auction - Fr8Auctions";
        break;
      case "/auction-management/edit-auction":
        document.title = "Edit an Auction - Fr8Auctions";
        break;
      case "/lot-management":
        document.title = "Lot Management - Fr8Auctions";
        break;
      case "/lot-management/createLot":
        document.title = "Create a Lot - Fr8Auctions";
        break;
      case "/lot-management/edit-lot":
        document.title = "Edit a Lot - Fr8Auctions";
        break;
      case "/bids-management":
        document.title = "Bid Management - Fr8Auctions";
        break;

      case "/bids-management/details":
        document.title = "Bid Details - Fr8Auctions";
        break;
      case "/bids-management/details/winner":
        document.title = "Bid Winner - Fr8Auctions";
        break;
      case "/companies":
        document.title = "Invoice Management - Fr8Auctions";
        break;
      case "/companies/invoice-management":
        document.title = "Invoice Management - Fr8Auctions";
        break;
      case "/companies/invoice-management/add-payment":
        document.title = "Add Payment - Fr8Auctions";
        break;
      case "/companies/invoice-management/bol":
        document.title = "BOL - Fr8Auctions";
        break;
      case "/invoice-management/customer-bol":
        document.title = "BOL - Fr8Auctions";
        break;
      case "/auctions":
        document.title = "Auction - Fr8Auctions";
        break;
      case "/auctions/view-auction-lot":
        document.title = "View Auction Lots - Fr8Auctions";
        break;
      case "/bids-details":
        document.title = "Bid Details - Fr8Auctions";
        break;
      case "/bids-details/placeallbid":
        document.title = "Bid Details - Fr8Auctions";
        break;
      case "/on-site-visit":
        document.title = "Wish List - Fr8Auctions";
        break;
      case "/company-management/bids":
        document.title = "Company Bids - Fr8Auctions";
        break;
      case "/auctioninvoice":
        document.title = "Invoice Management - Fr8Auctions";
        break;
      case "/addinvoice":
        document.title = "Invoice Management - Fr8Auctions";
        break;
      case "/check-in":
        document.title = "Check-In/Check-Out - Fr8Auctions";
        break;
      case "/profile":
        document.title = "Profile - Fr8Auctions";
        document.title = user.role?.name.toLowerCase() === "admin" ? "Edit Profile - Fr8Auctions" : "View Profile - Fr8Auctions";
        break;
      case "/reports":
        document.title = "Reports - Fr8Auctions";
        break;
      case "/auctioninvoice/invoice-management":
        document.title = " Invoice Management - Fr8Auctions";
        break;
      case "/auctioninvoice/invoice-management/add-payment":
        document.title = " Invoice Management - Fr8Auctions";
        break;
      default:
        document.title = "FR8-Auctions - Fr8Auctions";
        break;
    }
  }, [location]); // Dependency array ensures this runs on location change

  return null; // This component does not render anything
};

export default RouteTitleUpdater;
